import { render } from "./InscriptionTbody.vue?vue&type=template&id=39c6da9f&scoped=true"
import script from "./InscriptionTbody.vue?vue&type=script&lang=js"
export * from "./InscriptionTbody.vue?vue&type=script&lang=js"

import "./InscriptionTbody.vue?vue&type=style&index=0&id=39c6da9f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39c6da9f"]])

export default __exports__